'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};



//////////////////
// WEBPACK FOOTER
// ./~/string.prototype.trim/shim.js
// module id = 1157
// module chunks = 0